import { TableColumn } from '@silverfort/sf-components';
import { TokenRow } from './types';
import PairedAtCell from './components/PairedAtCell';
import LastUsedCell from './components/LastUsedCell';
import TypeCell from './components/TypeCell';

export const TOKEN_TABLE_COLUMNS: TableColumn<TokenRow>[] = [
    {
        columnKey: 'idDisplay',
        title: 'Token ID'
    },
    {
        columnKey: 'type',
        title: 'Type',
        render: TypeCell
    },
    {
        columnKey: 'name',
        title: 'Name'
    },
    {
        columnKey: 'pairedAt',
        title: 'Paired',
        render: PairedAtCell
    },
    {
        columnKey: 'lastUsed',
        title: 'Last used',
        render: LastUsedCell
    }
];

export const ACTIVE_TOKEN_LAST_USED_MONTHS_THRESHOLD = 6;
